// extracted by mini-css-extract-plugin
module.exports = {"container":"az_tRb","imageContainer":"az_uRb","image":"az_vRb","heading":"az_wRb","description":"az_xRb"};